import React, { Component } from "react";
import Fade from "react-reveal/Fade";
import SimpleReactValidator from "simple-react-validator";

import SectionTitle from "../SectionTitle/SectionTitle";
import sendPic from "../../assets/img/send.svg";
import "./ContactUs.css";

const API_Message = process.env.REACT_APP_API_MESSAGE;
// const API_Message = "http://localhost:3001/message";

export default class ContactUs extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      message: "",
      isSending: false,
      isMessageSent: false,
      sentMessssage: "",
      error: false
    };
    this.validator = new SimpleReactValidator({
      validators: {
        name: {
          // name the rule
          message: "يرجى كتابة الاسم بشكل صحيح",
          rule: (val, params, validator) => {
            // regex to match name (only alphabet)
            return (
              validator.helpers.testRegex(
                val,
                /^[\u0621-\u064Aaa-zA-Z]+(([',. -][\u0621-\u064Aaa-zA-Z ])?[\u0621-\u064Aaa-zA-Z]*)*$/
              ) && params.indexOf(val) === -1
            );
          },
          messageReplace: (message, params) =>
            message.replace(":values", this.helpers.toSentence(params)), // optional
          required: true // optional
        }
      },
      messages: {
        email: "يرجى كتابة بريد إلكتروني صحيح.",
        name: "يرجى كتابة الاسم بشكل صحيح",
        default: "* هذا الحقل مطلوب"
      }
      // autoForceUpdate: this
    });
  }

  handelMessage = e => {
    e.preventDefault();
    const { name, email, message } = this.state;
    if (this.validator.allValid()) {
      try {
        this.setState({ isSending: true });
        fetch(API_Message, {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name,
            email,
            message
          })
        })
          .then(res => res.json())
          .then(res => this.showStatusMessage(res))
          .then(() => this.resetForm())
          .catch(err => console.log(err));
      } catch (err) {
        return (
          this.setState({
            isSending: false,
            sentMessssage: "فشل الارسال, حاول مجددًا"
          }),
          // to hide the message after 2 seconds
          setTimeout(() => {
            this.setState({
              sentMessssage: ""
            });
          }, 2000)
        );
      }
    } else {
      this.validator.showMessages(); // to show error in fields
      // this.forceUpdate();
    }
  };

  resetForm = () => {
    this.setState({
      isSending: false,
      name: "",
      email: "",
      message: ""
    });
  };

  showStatusMessage = res => {
    if (res.msg) {
      return this.setState(
        {
          isSending: false,
          isMessageSent: true,
          sentMessssage: "تم الارسال"
        },
        () => {
          setTimeout(() => {
            this.setState({
              isMessageSent: false,
              sentMessssage: ""
            });
          }, 2000);
        }
      );
    } else {
      return this.setState(
        {
          sentMessssage: "فشل الارسال, حاول مجددًا"
        },
        () => {
          setTimeout(() => {
            this.setState({
              // isSending: false,
              sentMessssage: ""
            });
          }, 2000);
        }
      );
    }
  };
  render() {
    return (
      <section id="contact-us" className="section">
        <Fade>
          <SectionTitle>اتصل بنا </SectionTitle>
        </Fade>
        <div className="container">
          <div className="columns is-centered">
            <Fade>
              <div className="column is-5 ">
                <h3 className="title is-5 has-text-centered mt-4 secondry-color">
                  تواصل معنا عبر البريد الإلكتروني
                </h3>
                <div className="form mt-3">
                  <div className="field">
                    <label className="label" />
                    <div className="control">
                      <input
                        className="input"
                        type="text"
                        placeholder="الاسم"
                        value={this.state.name}
                        onChange={e => this.setState({ name: e.target.value })}
                      />
                      {this.validator.message(
                        "name",
                        this.state.name,
                        "required|name",
                        { className: "validation-message-error" }
                      )}
                      {/* <div>{this.validator.showMessageFor("name")}</div> */}
                    </div>
                  </div>

                  <div className="field">
                    <label className="label" />
                    <div className="control">
                      <input
                        className="input"
                        type="email"
                        placeholder="البريد الإلكتروني"
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                      />
                      {this.validator.message(
                        "email",
                        this.state.email,
                        "required|email",
                        { className: "validation-message-error" }
                      )}
                      {/* <div>{this.validator.showMessageFor('email')}</div> */}
                    </div>
                  </div>

                  <div className="field">
                    <label className="label" />
                    <div className="control">
                      <textarea
                        className="textarea"
                        placeholder="الرسالة"
                        value={this.state.message}
                        onChange={e =>
                          this.setState({ message: e.target.value })
                        }
                      />
                      {this.validator.message(
                        "message",
                        this.state.message,
                        "required",
                        { className: "validation-message-error" }
                      )}
                      {/* <div>{this.validator.showMessageFor('message')}</div> */}
                    </div>
                  </div>

                  <button
                    className={`submit-msg button is-outlined has-text-centered ${
                      this.state.isSending ? "is-loading" : ""
                    }`}
                    onClick={e => this.handelMessage(e)}
                  >
                    {" "}
                    ارسال{" "}
                    <img
                      style={this.state.isSending ? { display: "none" } : {}}
                      src={sendPic}
                      alt="send icon"
                    />
                  </button>
                </div>
                {this.state.isMessageSent ? (
                  <p className="notification is-primary">
                    {this.state.sentMessssage}
                  </p>
                ) : this.state.isMessageSent && !this.state.isSending ? (
                  <p className="notification is-danger">
                    {this.state.sentMessssage}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </Fade>

            <Fade>
              <div className="column  is-1 border-left mt-4" />
            </Fade>

            <Fade>
              <div className="column is-5 has-text-centered">
                <h3 className="title is-5 has-text-centered mt-4 secondry-color">
                  اتصل بنا
                </h3>
                <div className="contact-us-info mt-1">
                  <a
                    className="subtitle mt-5"
                    href="mailto:GovAcademy@yesser.gov.sa"
                  >
                    GovAcademy@yesser.gov.sa
                  </a>
                  <p className="subtitle mt-5">
                    <span>المملكة العربية السعودية</span>
                    <br />
                    <span>الرياض - حي النخيل - المدينة الرقمية</span>
                    <br />
                    <span>مبنى وزراة الاتصالات وتقنية المعلومات </span>
                  </p>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </section>
    );
  }
}
